import { defineStyle } from '@chakra-ui/react';

export const lg = defineStyle({
  height: '64px',
  textStyle: 'xl',
  paddingY: '17px',
  paddingX: 4,
});

export const md = defineStyle({
  height: '48px',
  textStyle: 'md',
  paddingY: 1.5,
  paddingX: 3,
});

export const sm = defineStyle({
  height: '40px',
  textStyle: 'sm',
  paddingY: '9px',
  paddingX: 2,
});

export const screenStd = defineStyle({
  height: { base: '40px', '4k': '48px' },
  textStyle: 'screenStd',
  paddingX: 'standardM',
});

export const toggleS = defineStyle({
  width: 'max-content',
  height: { base: '32px', '4k': '48px' },
  textStyle: 'screenSm',
  paddingX: 'standardXS',
});

export const toggleM = defineStyle({
  width: '100%',
  height: { base: '48px', '4k': '56px' },
  textStyle: 'screenStd',
  paddingX: 'standardM',
});
